import { isPlatformBrowser } from '@angular/common';
import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetworkService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);
  private readonly snackBar = inject(MatSnackBar);

  private readonly onlineSubject = new BehaviorSubject<boolean>(
    this.isBrowser ? navigator.onLine : true
  );
  online$ = this.onlineSubject.asObservable();

  setOnlineStatus(isOnline: boolean): void {
    if (!this.isBrowser) {
      return;
    }

    // Only fire when status actually changes
    if (isOnline !== this.onlineSubject.value) {
      this.onlineSubject.next(isOnline);

      this.snackBar.open(isOnline ? 'Back online' : 'No internet connection', 'Close', {
        duration: isOnline ? 3000 : undefined,
      });
    }
  }
}
